export default function CompanyPress() {
  return (
    <div className="text-black">
      <h1>Press Releases</h1>
      <p>Not implemented in demo.</p>
    </div>
  );
}
